import { RefObject } from 'react';

export const scrollToElement = (
    element: RefObject<HTMLDivElement>,
    yOffset = 0
): void => {
    if (element.current) {
        const elementPosition =
            element.current.getBoundingClientRect().top - yOffset;
        const offsetPosition = elementPosition + window.pageYOffset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });
    }
};
